import { Instagram, ShoppingBag, Tag, BadgePercent } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SHOP, IMG } from "@/data/site";
import { trackEvent } from "@/lib/analytics";

const PROMOS = [
    {
        judul: "Coffee Signature 10K",
        detail:
            "Espresso 1 shot, creamer, brown sugar, dan susu — harga spesial menu andalan Yuhuku.",
        catatan: "Promo pernah tayang di Instagram — cek IG untuk promo terkini.",
    },
    {
        judul: "Seliter hemat buat ramai",
        detail:
            "Signature & Arena 75K, Chocolate & RedVelvet 115K, Matcha 125K — cukup untuk 6–7 porsi.",
        catatan: "Cocok buat acara, arisan, atau stok kulkas kantor.",
    },
    {
        judul: "Bottled 250ml siap bawa",
        detail:
            "Signa & Arena 22K, Choco 32K, RedVelvet 33K, Matcha 42K — simpan dingin, tahan untuk dibawa jalan.",
        catatan: "Tersedia di cafe & GoFood selama stok ada.",
    },
];

export default function Promo() {
    return (
        <div className="pt-24 lg:pt-32" data-testid="promo-page">
            <header className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <span className="eyebrow">Yang bikin dompet senang</span>
                </Reveal>
                <Reveal delay={0.08}>
                    <h1 className="mt-4 font-display text-5xl font-extrabold tracking-tighter text-ink sm:text-6xl lg:text-7xl">
                        <span className="text-accent">Promo.</span>
                    </h1>
                </Reveal>
            </header>

            <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
                <Reveal>
                    <div className="mx-auto max-w-3xl overflow-hidden rounded-[2.5rem] border border-ink/5 bg-white shadow-lift">
                        <img
                            src={IMG.bottled}
                            alt="Botol bottled Yuhuku Kopi"
                            className="aspect-[16/10] w-full object-cover"
                        />
                        <div className="px-8 py-6 text-center">
                            <p className="font-display text-2xl font-extrabold tracking-tight text-accent">
                                Signature 10K
                            </p>
                            <p className="mt-1.5 text-sm text-ink-muted">
                                Promo andalan yang pernah tayang di Instagram —
                                follow untuk jangan sampai kelewat yang
                                berikutnya.
                            </p>
                        </div>
                    </div>
                </Reveal>

                <div className="mt-14 grid gap-6 md:grid-cols-3">
                    {PROMOS.map((p, i) => (
                        <Reveal key={p.judul} delay={i * 0.08}>
                            <div
                                data-testid={`promo-card-${i + 1}`}
                                className="flex h-full flex-col rounded-3xl border border-ink/5 bg-white p-7 shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
                            >
                                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-soft text-accent">
                                    {i === 0 ? (
                                        <BadgePercent className="h-5 w-5" />
                                    ) : (
                                        <Tag className="h-5 w-5" />
                                    )}
                                </span>
                                <h2 className="mt-5 font-display text-xl font-extrabold tracking-tight text-ink">
                                    {p.judul}
                                </h2>
                                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-ink-muted">
                                    {p.detail}
                                </p>
                                <p className="mt-5 text-xs italic text-ink-muted/80">
                                    {p.catatan}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.1}>
                    <div className="mt-14 overflow-hidden rounded-[2.5rem] bg-ink px-6 py-14 text-center text-bg sm:px-12">
                        <h2 className="font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
                            Promo terbaru selalu di Instagram
                        </h2>
                        <p className="mx-auto mt-3 max-w-md text-sm text-bg/70">
                            Jangan sampai kelewat — follow dan nyalakan
                            notifikasinya.
                        </p>
                        <div className="mt-8 flex flex-wrap justify-center gap-3.5">
                            <a
                                href={SHOP.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="promo-cta-instagram"
                                className="btn-primary"
                            >
                                <Instagram className="h-4 w-4" /> Follow {SHOP.instagramHandle}
                            </a>
                            <a
                                href={SHOP.gofood}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="promo-cta-gofood"
                                onClick={() => trackEvent("cta_click", { cta: "gofood_promo" })}
                                className="rounded-full border border-white/25 px-7 py-3.5 text-sm font-semibold text-bg transition-all hover:-translate-y-0.5 hover:border-white/50"
                            >
                                <ShoppingBag className="inline h-4 w-4" /> Pesan di GoFood
                            </a>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    );
}